export function playEmLoop() {}

/**
 * Toca o áudio uma única vez.
 *
 * @param {string} URL do arquivo de áudio
 * @return {void}
 */
export function play(url, opts = {}) {
    let audio = new Audio(url)

    if (opts.volume) {
        audio.volume = opts.volume
    }

    audio.play()
}

export function playInLoop(url) {
    let audio = new Audio(url)
    let stopped = false

    audio.addEventListener('ended', () => {
        if (stopped) return
        console.log('playing again')
        audio.currentTime = 0
        audio.play()
    })

    let stop = () => {
        audio.pause()
        stopped = true
    }

    audio.play()
    return stop
}
